import React from "react";
import releaseBackgroundImg from "./release-bg.jpg"; // 765 × 650
import { injectIntl } from "react-intl";

export const GenericImage = ({ title, subTitle, text, subText }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 392 240">
    <image xlinkHref={releaseBackgroundImg} width="765" height="650" />
    <g transform="matrix(1.1 0 0 1.1 -44 -9.5799)">
      <g transform="matrix(.6 0 0 .6 100.58182 46)">
        <path d="M392 219.333c0 11.047-8.954 20-20 20H20c-11.046 0-20-8.953-20-20V20C0 8.954 8.954 0 20 0h352c11.046 0 20 8.954 20 20z" fill="#ef4136"/>
        <path d="M0 91.333h392v130H0z" fill="#fff"/>
      </g>
      <text y="80" x="217" fontSize="30" fontFamily="Fredoka One, sans-serif" textAnchor="middle" fill="#fff">{title}</text>
      <text y="92" x="217" fontSize="9" fontFamily="Raleway, sans-serif" textAnchor="middle" fill="#fff">{subTitle}</text>
      <text y="135" x="217" fontSize="30" fontFamily="Courgette, sans-serif" textAnchor="middle">{text}</text>
      <text y="160" x="217" fontSize="15" fontFamily="Raleway, sans-serif" textAnchor="middle">{subText}</text>
    </g>
  </svg>
);

export const ReleaseImage = ({ version }) => (
  <GenericImage
    title="NEW"
    subTitle="VERSION AVAILABLE"
    text="Screenpresso"
    subText={version}
  />
);

export const ReleaseImageIntl = injectIntl(({ locale, version, date, intl }) => (
  <GenericImage
    title={intl.formatMessage({
      id: "release-image.new",
    })}
    subTitle={intl.formatMessage({
      id: "release-image.version",
    })}
    text="Screenpresso"
    subText={`${new Date(date).toLocaleDateString(locale, { month: "long", year: "numeric" })} (${version})`}
  />
));
